import type { LalSegmentApi } from '@openx/types/segments';

export const isLalSegmentDeleted = (lalSegment: LalSegmentApi) => !!lalSegment.is_archived;
